import { api } from '@/shared/api/client';
import type {
  GetUnresolvedQuizzesRequest,
  GetUnresolvedQuizzesResponse,
} from '../model/dto';

export const getUnresolvedQuizzes = async (
  params: GetUnresolvedQuizzesRequest,
) => {
  const { data } = await api.get<GetUnresolvedQuizzesResponse>(
    `/courses/${params.id}/unresolved-quizzes/`,
  );
  return data;
};
